export default __webpack_public_path__ + "static/media/black_and_white_woman_line.585e33e4.jpg";